import { render } from "./accessoireListe.vue?vue&type=template&id=c2fa2aa0&scoped=true"
import script from "./accessoireListe.vue?vue&type=script&lang=js"
export * from "./accessoireListe.vue?vue&type=script&lang=js"

import "./accessoireListe.vue?vue&type=style&index=0&id=c2fa2aa0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fa2aa0"]])

export default __exports__